import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadCreditNotes = async () => {
  let response = await Axois.get('/credit-notes').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadCreditNote = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/invoices');
        const responseData = await requests.data;
        return {...responseData, invoice: {}, entry: { }};
        // return {journals: [], accounts:[], entry:{}, transactions:[]};

      default:
        let response = await Axois.get('/credit-notes/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return {journals: [], accounts:[], entry:{}, transactions:[]};
    }
  }catch (err) {
    console.log(err);
  }
}


const useCreditNotesAPI = () => {

  const save = async (data, success) => {
    try {
      const response = await Axois.post('/credit-notes', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('saved_invoice_response', {status: 'draft', number: responseData.number});
    }catch(err) {
      console.log(err);
    }
  };

  const postCreditNote = async (number, data, success) => {
    try {
      const response = await Axois.patch('/credit-notes/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('credit_note_posted', {status: 'posted'});
    }catch (err) {
      console.log(err);
    }
  }

  const update = async (number, data, success) => {
    try {
      const response = await Axois.put('/credit-notes'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      // EventEmitter.dispatch('saved_invoice_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      console.log(err);
    }
  };

  return { save, update, postCreditNote };
}


export default useCreditNotesAPI;